export const renderPremiumText = (text, checkPremiumFunction) => {
  const showPremiumIcon = checkPremiumFunction(false);
  if (showPremiumIcon) {
    return `<span>${text}</span><i class="premium-icon icon mapsa-premium-plan" />`;
  } else {
    return text;
  }
};
